import { render } from "./AwardsSection.vue?vue&type=template&id=a297347a&scoped=true"
import script from "./AwardsSection.vue?vue&type=script&lang=js"
export * from "./AwardsSection.vue?vue&type=script&lang=js"

import "./AwardsSection.vue?vue&type=style&index=0&id=a297347a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a297347a"]])

export default __exports__